(function($) {
  $.fn.appendAttr = function(attrName, suffix) {
    this.attr(attrName, function(i, val) {
      return val + suffix
    })
    return this
  }
})(jQuery)
